import { simpleHash } from "@tamagui/helpers";
import { createVariable, isVariable } from "./createVariable";
const createVariables = (tokens, parentPath = "", isFont = false) => {
  const res = {};
  let i = 0;
  for (let keyIn in tokens) {
    i++;
    const val = tokens[keyIn];
    const keyWithPrefix = keyIn[0] === "$" ? keyIn : `$${keyIn}`;
    const key = keyWithPrefix.slice(1);
    if (isVariable(val)) {
      res[key] = val;
      continue;
    }
    const niceKey = simpleHash(key);
    let name = isFont ? niceKey.slice(0, 2) : i;
    name = parentPath ? `${parentPath}-${name}` : niceKey;
    if (val && typeof val === "object") {
      res[key] = createVariables(tokens[key], name);
      continue;
    }
    res[key] = isVariable(val) ? val : createVariable({ val, name, key: keyWithPrefix });
  }
  return res;
};
export {
  createVariables
};
//# sourceMappingURL=createVariables.js.map
